export const environment = {
    production: false,
    feUrl: '',
    apiUrl: '',
    algoliaApplicationId: '',
    algoliaApiKey: '',
};
